module.exports = __webpack_public_path__ + "static/media/L1.8b37dcac.png";